import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` that fallbacks to `useEffect` on server side
 * rendering.
 */
var useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
var useIsomorphicEffect$1 = useIsomorphicEffect;

export { useIsomorphicEffect$1 as default };
//# sourceMappingURL=use-isomorphic-effect.esm.js.map
